<template>
  <el-input v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </el-input>
</template>
<script>
export default {
  name: "aia-input"
};
</script>